const formatDeliveryRate = row => {
  const rate = (row.Success / (row.Success + row.Errors)) * 100;
  return isNaN(rate) ? 'N/A' : rate.toFixed(2) + '%';
};

export default formatDeliveryRate;
